import { useEffect } from 'react';

/**
 * @param {Object} props
 * @param {boolean} props.success
 * @param {boolean} props.loading
 */
export const useCandidateScrollToSection = ({ success, loading }) => {
  useEffect(() => {
    if (!window.location.hash) return;
    if (!success && !loading) return;

    const element = document.getElementById(window.location.hash.slice(1));

    if (!element) return;
    element.scrollIntoView({ behavior: 'smooth' });
  }, [success, loading]);
};
